module.exports = __webpack_public_path__ + "img/zinc_gallery_5.1cd599f2.jpg";